import { render } from "./ArtistCartDesignSkeleton.vue?vue&type=template&id=08427b2c&scoped=true"
const script = {}

import "./ArtistCartDesignSkeleton.vue?vue&type=style&index=0&id=08427b2c&scoped=true&lang=css"

import exportComponent from "C:\\wamp64\\www\\artware\\website\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08427b2c"]])

export default __exports__